import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button, SkipNav } from '@ver-uds/uswds-react';
import { useAuthState } from '@vis-auth/react';
import Messages from '../../components/message-center/messages.component';
import WelcomeBanner from '../../components/welcome-banner/welcome-banner.component';
import { Roles, Routes } from '../../constants';
import { isToggleEnabled } from '@save/utils';
import TrainingModal from '../../components/training-modal/training-modal';

const NUMBER_OF_MESSAGES = 3;

export default function Home() {
  const { user } = useAuthState();

  if (!!user?.roles?.includes(Roles.ONBOARDING)) {
    return <Redirect to={Routes.AGENCY_REGISTRATION} />;
  }

  return (
    <>
      <Helmet>
        <title>SAVE - Home</title>
      </Helmet>
      <SkipNav.MainContent className="save-home">
        <WelcomeBanner />
        <div className="grid-container">
          <h1 className="font-heading-xl margin-top-4">Additional Verification Response Time</h1>
          <div className="additional-verification-info tablet:grid-col-9 padding-top-2 padding-bottom-4">
            <span className="additional-verification-text">
              Processing time for each step of additional verification may vary. Please check{' '}
              <a href="https://www.uscis.gov/save">www.USCIS.gov/SAVE</a> for the current processing time.
            </span>
          </div>
          <hr className="tablet:grid-col-9"></hr>
          <h1 className="font-heading-xl margin-top-4">Message Center</h1>
          <Messages count={NUMBER_OF_MESSAGES} />
          <Button
            type="button"
            variant="outline"
            aria-label="View All"
            as="a"
            href="/save/app/client/ui/home/messageCenter"
            className="margin-bottom-4 margin-top-4"
          >
            View All
          </Button>
        </div>
        {isToggleEnabled('REVEAL_TRAINING_INDICATOR') ? <TrainingModal /> : <></>}
      </SkipNav.MainContent>
    </>
  );
}
